import { useContext, useState } from "react"
import toast from "react-hot-toast";
import { logar } from "../services/auth";
import { AuthContext } from "../contexts/auth";
import { useNavigate } from "react-router-dom";

const useLoginState = () => {
    const navigate = useNavigate()
    const { signIn } = useContext(AuthContext)
    const [login, setLogin] = useState('')
    const [empresa, setEmpresa] = useState('')
    const [senha, setSenha] = useState('')
    
    const [submit, setSubmit] = useState(false)
    
    const _postLogin = () => {
        if (submit) {
            return;
        }

        let empresaValida = false;
        let loginValido = false;
        let senhaValida = false;
    
        if (login !== '') {
            loginValido = true;
        } else {
            toast.error('Login inválido.')
        }
    
        if (senha !== '') {
            senhaValida = true;
        } else {
            toast.error('Senha inválida.')
        }
    
        if (empresa !== '') {
            empresaValida = true;
        } else {
            toast.error('Empresa inválida.')
        }
        if (loginValido && senhaValida && empresaValida){
            setSubmit(true);
            logar(login.replace(' ', ''), senha, empresa.toUpperCase())
            .then(async json => {
                
                if (!json.user.is_management){
                    console.log("Não é gestor")
                    toast.error('Login invalido. Tente outro login ou senha.')
                } else if(json.token){
                    signIn(json);
                    navigate('/gestor/dashboard')
                }
                setSubmit(false);

            })
            .catch(error => {
                toast.error(error.message)
                setSubmit(false);
                
            })
        }
    }


    return {
        empresa: {value: empresa, set:setEmpresa},
        login: {value: login, set:setLogin},
        senha: {value: senha , set:setSenha},
        submit: {value: submit, set:_postLogin}
    }
}

export default useLoginState